import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';

import * as OptionController from '../../../controllers/OptionsController';
import { GlobalState } from '../../../states/global-state';
import type {
  CustomerAnswerSelectNoFloatOptionType,
  CustomerAnswerSelectNoFloatControl,
} from 'src/types/form-config';
import { Signal, signal, useSignal, useSignalEffect } from '@preact/signals';
import { isSelectedCustomerAnswer } from '../../../routes/kyc/utils';

type PasswordPropsType = {
  placeholder: string;
  name: string;
  display: string;
  hasValidate?: boolean;
};

const CustomPasswordControl = (props: PasswordPropsType) => {
  const type: any = useSignal('password');

  return (
    <div class="input-group mb-3 form-group">
      <div class="form-floating  ">
        <input
          autocomplete="new-password"
          type={type}
          class="form-control input"
          id={props.name}
          name={props.name}
          placeholder={props.placeholder}
          {...(() => {
            if (props.hasValidate == undefined ? true : props.hasValidate) {
              return {
                'data-validator':
                  'required=true, string=true, min=8, has-space=true, has-numeric=true, has-lowercase=true, has-uppercase=true, has-special=true, max=13',
              };
            }
            return {};
          })()}
        />
        <label for={props.name}>{props.display}</label>
      </div>

      <span
        class="input-group-text"
        onClick={() =>
          (type.value = type.value == 'password' ? 'text' : 'password')
        }
      >
        <i
          class={`fa ${type == 'password' ? 'fa-eye' : 'fa-eye-slash'}`}
          aria-hidden="true"
        />
      </span>
    </div>
  );
};

export default CustomPasswordControl;
